export const tarotLoveDeck = [
  {
    id: 0,
    card: "The Fool",
    text: "หมายถึง การเริ่มต้นอะไรใหม่ ๆ การเสี่ยงอันตราย หากว่าเปิดได้ไพ่ใบนี้แล้วล่ะก็ เส้นทางใหม่ที่เพื่อน ๆ จะเดินไปอาจมีความเสี่ยง แต่เป็นความเสี่ยงที่เพื่อน ๆ ต้องการ รู้ว่าเสี่ยงแต่คงต้องขอลอง",
    love: {
      single:
        "ไพ่ใบนี้ชวนให้เปิดใจต่อสิ่งไม่คาดฝัน คุณอาจได้พบคนที่เข้ามาแบบกะทันหันจากการเดินทาง งานอดิเรก หรือกิจกรรมใหม่ ๆ มีโอกาสคุยทำความรู้จักกันแบบสบาย ๆ และค่อย ๆ ศึกษานิสัยใจคอจนความสัมพันธ์งอกงามขึ้นมาเอง",
      couple:
        "ความรักมีลมอ่อน ๆ ของการเริ่มต้นอีกครั้ง รู้สึกปลอดโปร่งกว่าเดิม หากเคยค้างคาใจกันจะได้เคลียร์กันเร็ว ๆ นี้ เพียงแต่ต้องให้กันและกันมีพื้นที่ และวางแผนร่วมกันก่อนลุยสิ่งใหม่ ๆ",
      sources: [
        "https://www.myhora.com/horoscope/tarot-love.aspx",
        "https://www.thairath.co.th/horoscope/tarot/love",
      ],
    },
    image: "/images/tarot/thefool.jpeg",
  },
  {
    id: 1,
    card: "The Magician",
    text: "หมายถึง ความทะเยอทะยาน การลงมือทำ ไพ่บอกว่าเพื่อน ๆ เก่งมาก อยากทำอะไรก็ลุยให้เต็มที่เลย เพราะไฟในตัวมีเยอะพอ ๆ กับความสามารถ ดังนั้นลุยได้เลยไม่ต้องยั้ง",
    love: {
      single:
        "เสน่ห์คำพูดและการสื่อสารทำงานสุด ๆ คุณมีโอกาสเริ่มคุยกับคนเก่ง มีของ เคมีดีตั้งแต่ต้น หากใช้ความมั่นใจอย่างพอดี ความสัมพันธ์จะเดินหน้าไว",
      couple:
        "ช่วงแห่งการคุยกันให้รู้เรื่อง วางเป้าหมายรักร่วมกันแล้วจูนวิธีไปให้ถึง ระวังการ ‘คุมเกม’ หรือพูดเก่งเกินจนอีกฝ่ายรู้สึกถูกชักนำ—เปิดพื้นที่ให้ฟังกันมากขึ้น",
      sources: [
        "https://www.myhora.com/horoscope/tarot-love.aspx",
        "https://www.thairath.co.th/horoscope/tarot/love",
      ],
    },
    image: "/images/tarot/themagician.jpeg",
  },
  {
    id: 2,
    card: "The High Priestess",
    text: "หมายถึง ความฉลาด มีความรู้ความสามารถ เป็นตัวแทนของคนเก่งมากความสามารถ แต่มักซ่อนสิ่งนั้นเอาไว้ภายในรูปลักษณ์นิ่งเงียบที่แสดงให้ภายนอกได้เห็น",
    love: {
      single:
        "ความสัมพันธ์ยังคลุมเครือและต้องอาศัยสัญชาตญาณ อาจมีคนแอบชอบหรือคนที่ยังไม่เปิดเผยตัวจริงใจ รอเวลาสักนิดและสังเกตรายละเอียดให้มากก่อนตัดสินใจ",
      couple:
        "เข้าใจกันลึกซึ้งแม้ไม่ได้พูดเยอะ แต่มีบางเรื่องเก็บงำอยู่ เปิดใจคุยอย่างอ่อนโยนจะช่วยคลี่คลายความกังวล และทำให้ความไว้วางใจแน่นขึ้น",
      sources: [
        "https://www.myhora.com/horoscope/tarot-love.aspx",
        "https://www.thairath.co.th/horoscope/tarot/love",
      ],
    },
    image: "/images/tarot/thehighpriestess.jpeg",
  },
  {
    id: 3,
    card: "The Empress",
    text: "หมายถึง ความอุดมสมบูรณ์ ความเป็นแม่ เปิดได้ไพ่ใบนี้บอกเลยว่าจะเจอแต่ความสุขความสบาย เงินทองมั่งมี หรืออาจหมายถึงโอกาสตั้งครรภ์ได้ด้วย",
    love: {
      single:
        "เสน่ห์คุณกำลังบานสะพรั่ง มีคนเข้ามาเอ็นดูและดูแล ความสัมพันธ์ก้าวหน้าแบบช้า ๆ แต่มั่นคง บางคนเจอคนที่เข้ากับไลฟ์สไตล์และครอบครัวได้ดี",
      couple:
        "รักอิ่มเอมและเกื้อกูลกันมากขึ้น บรรยากาศบ้าน/ครอบครัวอบอุ่น มีลุ้นข่าวดีเรื่องบ้านเรือนหรือสมาชิกใหม่ในครอบครัว",
      sources: [
        "https://www.myhora.com/horoscope/tarot-love.aspx",
        "https://www.thairath.co.th/horoscope/tarot/love",
      ],
    },
    image: "/images/tarot/theempress.jpeg",
  },
  {
    id: 4,
    card: "The Emperor",
    text: "หมายถึง การมีอำนาจ ชอบสั่ง และไม่ยอมใคร เพื่อน ๆ อาจอยู่ในสถานการณ์ที่ต้องยอมทำตามผู้ใหญ่ ถูกบังคับจากคนมีอำนาจมากกว่าก็เป็นได้ และยังหมายถึงความมั่นคงได้อีกด้วย",
    love: {
      single:
        "มีแนวโน้มพบคนจริงจัง มั่นคง อาจอายุมากกว่าหรือมีตำแหน่งหน้าที่ดี ความสัมพันธ์คืบหน้าช้าแต่ยืนยาวถ้าคุณเปิดใจให้กรอบกติกาบางอย่าง",
      couple:
        "โครงสร้างและกติกาของคู่ชัดเจน รู้บทบาทกันดี ระวังคุมเข้มจนอีกฝ่ายอึดอัด—ผ่อนคลายบ้างแล้วความรักจะอบอุ่นขึ้น",
      sources: [
        "https://www.myhora.com/horoscope/tarot-love.aspx",
        "https://www.thairath.co.th/horoscope/tarot/love",
      ],
    },
    image: "/images/tarot/theemperor.jpeg",
  },
  {
    id: 5,
    card: "The Hierophant",
    text: "หมายถึง การมีความรู้ การแต่งงาน การรวมเป็นหนึ่ง พระคือตัวแทนของผู้มีความรู้และยังเป็นตัวแทนในการแต่งงานรวมเป็นครอบครัวเดียวกัน อาจหมายถึงการเป็นที่พึ่งพาของคนอื่น ๆ",
    love: {
      single:
        "มีโอกาสพบรักผ่านสังคม ชุมชน ศาสนสถาน หรือผู้ใหญ่ช่วยแนะนำ ความสัมพันธ์ค่อย ๆ เป็นทางการและน่าเชื่อถือ",
      couple:
        "คุยอนาคตร่วมกันอย่างเป็นระบบ เรื่องแต่งงาน สร้างครอบครัว หรือทำสัญญาร่วมกันจะชัดเจนขึ้น",
      sources: [
        "https://www.myhora.com/horoscope/tarot-love.aspx",
        "https://www.thairath.co.th/horoscope/tarot/love",
      ],
    },
    image: "/images/tarot/thehierophant.jpeg",
  },
  {
    id: 6,
    card: "The Lovers",
    text: "หมายถึง ความรัก การตัดสินใจ แน่นอนว่าใบนี้ต้องหมายถึงความรัก ได้พบเจอความรัก หรือต้องตัดสินใจเลือกสิ่งใดสิ่งหนึ่ง",
    love: {
      single:
        "มีเคมีแรงและโอกาสพบคนที่ใช่ แต่ก็มี ‘ทางเลือก’ ให้คิด คุณจะเริ่มชั่งใจว่าอยากเดินหน้าแบบจริงจังกับใคร—เชื่อใจหัวใจตัวเองและสื่อสารให้ชัด",
      couple:
        "รักหวานขึ้นแต่ก็มีเรื่องให้ตัดสินใจ เช่น ความสัมพันธ์ระยะยาว การย้ายที่อยู่ หรือจัดการบุคคลที่สาม เคลียร์ขอบเขตให้ตรงกันแล้วทุกอย่างจะราบรื่น",
      sources: [
        "https://www.myhora.com/horoscope/tarot-love.aspx",
        "https://www.thairath.co.th/horoscope/tarot/love",
      ],
    },
    image: "/images/tarot/thelovers.jpeg",
  },
  {
    id: 7,
    card: "The Chariot",
    text: "หมายถึง ความแน่วแน่ มุ่งมั่น ขยัน ทุ่มเท เมื่อเจอไพ่ใบนี้ เพื่อน ๆ ก็ต้องทำตัวให้แข็งแกร่งยิ่งกว่าม้าศึกถึงจะประสบความสำเร็จในสิ่งที่ทำ",
    love: {
      single:
        "ความรักขยับเมื่อคุณกล้ารุกและชัดเจน มีลุ้นพบคนจากการเดินทาง งานภาคสนาม หรือกิจกรรมแข่งขัน ตั้งเป้าแล้วค่อย ๆ ขับเคลื่อนสัมพันธ์ไปข้างหน้า",
      couple:
        "คู่รักพุ่งสู่เป้าหมายเดียวกันดี แต่ต้องบริหารอีโก้และอารมณ์ ระหว่างทางอย่าลืมฟังกันเพื่อไม่ให้การเดินทางร่วมกันสะดุด",
      sources: [
        "https://www.myhora.com/horoscope/tarot-love.aspx",
        "https://www.thairath.co.th/horoscope/tarot/love",
      ],
    },
    image: "/images/tarot/thechariot.jpeg",
  },
  {
    id: 8,
    card: "Strength",
    text: "หมายถึง ความแข็งแกร่ง บริหารจัดการเก่ง ไพ่นี้คือตัวแทนของหญิงสาวสุดแกร่ง มีอะไรเข้ามาก็ไม่อาจทำอะไรเธอได้ แถมยังจัดการสิ่งต่าง ๆ ได้เป็นอย่างดีอีกด้วย",
    love: {
      single:
        "ความอ่อนโยนและมั่นคงของคุณคือเสน่ห์หลัก ดึงดูดความสัมพันธ์ที่ค่อย ๆ โตบนพื้นฐานของความไว้ใจ รักที่เริ่มจากเพื่อนมีโอกาสพัฒนา",
      couple:
        "ผ่านปัญหาด้วยสติและความเข้าใจ อดทนฟังกันมากขึ้นจะใกล้ชิดกันกว่าเดิม ความผูกพันลึกขึ้นอย่างเป็นธรรมชาติ",
      sources: [
        "https://www.myhora.com/horoscope/tarot-love.aspx",
        "https://www.thairath.co.th/horoscope/tarot/love",
      ],
    },
    image: "/images/tarot/thestrength.jpeg",
  },
  {
    id: 9,
    card: "The Hermit",
    text: "หมายถึง ความสันโดษ โดดเดี่ยว วิเคราะห์ เมื่อเจอไพ่ใบนี้ก็คงเลี่ยงไม่พ้นการอยู่ตัวคนเดียว การใช้เวลารักษาเยียวยาจิตใจ หรือแม้แต่การใช้เวลาเพื่อคิดวิเคราะห์สิ่งต่าง ๆ รอบตัว อย่าได้ใจร้อนทำสิ่งใดเด็ดขาด",
    love: {
      single:
        "โสดอย่างมีคุณภาพ ใช้เวลาเรียนรู้ตัวเองและเยียวยาหัวใจ จนกว่าจะพร้อมเปิดรับใครใหม่ ความสัมพันธ์ที่เริ่มตอนนี้จะโตช้าแต่มั่นคง",
      couple:
        "ต้องการพื้นที่ส่วนตัวมากขึ้นเพื่อทบทวนเรื่องสำคัญ ระวังห่างเหิน หากขอเวลาคุยกันอย่างตั้งใจจะช่วยลดระยะห่าง",
      sources: [
        "https://www.myhora.com/horoscope/tarot-love.aspx",
        "https://www.thairath.co.th/horoscope/tarot/love",
      ],
    },
    image: "/images/tarot/thehermit.jpeg",
  },
  {
    id: 10,
    card: "The Wheel of Fortune",
    text: "หมายถึง โชคชะตา เปลี่ยนแปลง หากไพ่ใบนี้ปรากฏขึ้น เพื่อน ๆ ต้องเตรียมตัวให้ดี เพราะมีโอกาสเกิดเรื่องที่ไม่คาดฝันได้ มีการเปลี่ยนแปลงที่เราไม่อาจขัดขวางได้ อาจจะเป็นเรื่องดีหรือไม่ดีก็ได้เช่นกัน",
    love: {
      single:
        "โชคชะตาพาเจอรักแบบไม่ทันตั้งตัว อาจเริ่มคุยจากเหตุบังเอิญหรือโอกาสสั้น ๆ ถ้าเปิดใจทันเวลา ความสัมพันธ์จะหมุนไปในทิศทางดี",
      couple:
        "วงจรใหม่กำลังเริ่ม ระวังอารมณ์ขึ้นลงตามสถานการณ์ ใช้การปรับตัวและศรัทธาในกันและกันเป็นพวงมาลัยพาออกจากโค้งหักศอก",
      sources: [
        "https://www.myhora.com/horoscope/tarot-love.aspx",
        "https://www.thairath.co.th/horoscope/tarot/love",
      ],
    },
    image: "/images/tarot/wheeloffortune.jpeg",
  },
  {
    id: 11,
    card: "Justice",
    text: "หมายถึง การตัดสินใจ เท่าเทียม กฎหมาย หากเปิดเจอไพ่นี้แสดงว่าเพื่อน ๆ จะได้รับความยุติธรรม มีการตัดสินใจที่ก่อให้เกิดความเท่าเทียม หรืออาจจะเจอกับเรื่องราวเกี่ยวกับกฎหมายก็ได้เช่นกัน",
    love: {
      single:
        "ถึงเวลาจัดระเบียบหัวใจและสถานะความสัมพันธ์ คุยกันตรง ๆ ให้เคลียร์ว่าจะไปต่ออย่างไร คุณค่าของคุณจะดึงดูดคนที่แฟร์ต่อกัน",
      couple:
        "ความยุติธรรมและข้อตกลงชัดเจนทำให้รักนิ่งขึ้น อาจจัดทำสัญญา เอกสาร หรือขอทะเบียนให้มั่นคงกว่าเดิม",
      sources: [
        "https://www.myhora.com/horoscope/tarot-love.aspx",
        "https://www.thairath.co.th/horoscope/tarot/love",
      ],
    },
    image: "/images/tarot/justice.jpeg",
  },
  {
    id: 12,
    card: "The Hanged Man",
    text: "หมายถึง การรอคอย เสียสละ เพื่อน ๆ อาจได้เจอกับสถานการณ์ที่ไม่อาจตัดสินใจทำอะไรได้ ต้องอยู่นิ่ง ๆ ต้องรอคอย หรืออาจจะต้องเสียสละความสุขส่วนตัวบางอย่าง",
    love: {
      single:
        "ความรักเดินช้าเพราะต้องรอ หรือมีปัจจัยที่ควบคุมไม่ได้ ลองมองอีกมุมแล้วคุณจะเห็นทางเลือกใหม่ ๆ ที่เหมาะกับใจมากกว่า",
      couple:
        "เป็นช่วงต้องยอมเสียสละบางอย่างเพื่อความสัมพันธ์ เปลี่ยนมุมมองร่วมกันแล้วปมเดิม ๆ จะค่อย ๆ คลาย",
      sources: [
        "https://www.myhora.com/horoscope/tarot-love.aspx",
        "https://www.thairath.co.th/horoscope/tarot/love",
      ],
    },
    image: "/images/tarot/thehangedman.jpeg",
  },
  {
    id: 13,
    card: "Death",
    text: "หมายถึง การเปลี่ยนแปลง เกิดใหม่ เรื่องร้าย ๆ จะกลายเป็นดีนะคะ สิ่งต่าง ๆ ที่ว่าร้ายแรงแล้วจะเริ่มเปลี่ยนแปลงไปในทางที่ดีขึ้นทีละนิด",
    love: {
      single:
        "ปิดฉากเรื่องเดิมให้เรียบร้อยก่อนเริ่มต้นครั้งใหม่ คุณจะดึงดูดความสัมพันธ์ที่สดใสขึ้นเมื่อกล้าปล่อยอดีต",
      couple:
        "ความรักเปลี่ยนรูปครั้งใหญ่ บางคู่รีเซ็ตกติกาและเริ่มหน้าใหม่ บางคู่ยอมรับการสิ้นสุดเพื่อโอกาสที่ดีต่อใจของทั้งสองฝ่าย",
      sources: [
        "https://www.myhora.com/horoscope/tarot-love.aspx",
        "https://www.thairath.co.th/horoscope/tarot/love",
      ],
    },
    image: "/images/tarot/death.jpeg",
  },
  {
    id: 14,
    card: "Temperance",
    text: "หมายถึง การต่อรอง ผสมผสาน สมดุล ไพ่อยากแนะนำให้เพื่อน ๆ สร้างความสมดุลให้ชีวิต ต้องต่อรองและยอมอ่อนข้อบ้างเพื่อให้ได้สิ่งที่ต้องการ",
    love: {
      single:
        "รักที่ค่อย ๆ ผสมผสานจนลงตัว เปิดโอกาสให้กับความต่าง ทั้งพื้นเพ วัฒนธรรม หรือระยะทาง แล้วค่อย ๆ ประสานเข้าหากัน",
      couple:
        "การประนีประนอมคือตัวช่วยหลัก ทำกิจกรรมร่วมกัน เดินทางหรือวางแผนโปรเจ็กต์คู่เพื่อสร้างจุดกึ่งกลางใหม่",
      sources: [
        "https://www.myhora.com/horoscope/tarot-love.aspx",
        "https://www.thairath.co.th/horoscope/tarot/love",
      ],
    },
    image: "/images/tarot/temperance.jpeg",
  },
  {
    id: 15,
    card: "The Devil",
    text: "หมายถึง การควบคุม ผูกมัด ไร้ความหวัง ระวังให้ดี เมื่อไพ่ใบนี้ปรากฏขึ้นมา เพราะเพื่อน ๆ อาจเจอกับการควบคุม ถูกผูกมัดโดยไม่เต็มใจจนทำให้หมดพลังใจและหมดความหวัง",
    love: {
      single:
        "ระวังหลงเสน่ห์ความสัมพันธ์ที่ดึงดูดแต่ไม่อิสระ หรือวนลูปกับคนเดิม ๆ ตั้งขอบเขตตัวเองให้ชัดก่อนเดินหน้าต่อ",
      couple:
        "ประเด็นหึงหวง/ควบคุม/ผูกมัดต้องถูกพูดถึงอย่างตรงไปตรงมา วางกติกาเพื่อความปลอดภัยทางใจ และอย่าละเลยการดูแลตัวเอง",
      sources: [
        "https://www.myhora.com/horoscope/tarot-love.aspx",
        "https://www.thairath.co.th/horoscope/tarot/love",
      ],
    },
    image: "/images/tarot/thedevil.jpeg",
  },
  {
    id: 16,
    card: "The Tower",
    text: "หมายถึง การเปลี่ยนแปลงกะทันหัน การทะเลาะเบาะแว้ง ต้องเตรียมใจให้ดี เพราะอาจเจอเรื่องไม่คาดฝัน ได้รับข่าวสารที่ไม่ทันได้เตรียมใจ หรือเกิดเรื่องบาดหมางใหญ่โตกับคนรอบตัว",
    love: {
      single:
        "ความจริงที่ไม่คาดคิดจะทำให้คุณมองรักชัดขึ้น อาจตัดสินใจจบสิ่งที่ไม่เหมาะ แล้วพร้อมเริ่มใหม่อย่างเข้มแข็งและมีสติ",
      couple:
        "เหตุการณ์ปุ๊บปั๊บทำให้ความสัมพันธ์สั่นไหว ใช้โอกาสนี้ซ่อมแซมโครงสร้างรักให้ดีขึ้น หรือยอมรับความจริงเพื่อก้าวต่อไป",
      sources: [
        "https://www.myhora.com/horoscope/tarot-love.aspx",
        "https://www.thairath.co.th/horoscope/tarot/love",
      ],
    },
    image: "/images/tarot/thetower.jpeg",
  },
  {
    id: 17,
    card: "The Star",
    text: "หมายถึง ความหวัง ความสงบ แม้ฟ้าจะมืดมิด แต่หากไพ่ใบนี้โผล่ขึ้นมาก็เหมือนกับมีความหวังจากดวงดาวปรากฏขึ้น ควรทำตัวให้สงบเยือกเย็นเอาไว้",
    love: {
      single:
        "หัวใจเริ่มโปร่งเบา มีคนดี ๆ เข้าใกล้แบบเป็นธรรมชาติ ไม่ต้องเร่งรัด ปล่อยให้ความสบายใจพาเรื่องรักเติบโต",
      couple:
        "ช่วงเยียวยาและให้อภัยกันมากขึ้น กิจกรรมเรียบง่ายร่วมกันช่วยฟื้นประกายความหวังเดิม ๆ ให้กลับมา",
      sources: [
        "https://www.myhora.com/horoscope/tarot-love.aspx",
        "https://www.thairath.co.th/horoscope/tarot/love",
      ],
    },
    image: "/images/tarot/thestar.jpeg",
  },
  {
    id: 18,
    card: "The Moon",
    text: "หมายถึง ความกลัว ภาพลวงตา บางครั้งความกลัวก็อาจคืบคลานเข้ามาหาเพื่อน ๆ แบบไม่รู้ตัว แต่ไพ่อาจบอกให้พิจารณาให้ดีว่าสิ่งนั้นน่ากลัวจริง ๆ หรือเป็นเพียงภาพลวงตา",
    love: {
      single:
        "อารมณ์และความไม่ชัดเจนทำให้ตัดสินใจยาก ชะลอการผูกมัดไว้ก่อนรอให้ทุกอย่างโปร่งใส เมื่อเห็นภาพจริง ๆ แล้วค่อยเดินหน้า",
      couple:
        "ระวังการเข้าใจผิดจากความกังวลหรือเรื่องที่ยังไม่พูด คุยกันด้วยข้อเท็จจริงและรับฟังความรู้สึกของกันและกัน",
      sources: [
        "https://www.myhora.com/horoscope/tarot-love.aspx",
        "https://www.thairath.co.th/horoscope/tarot/love",
      ],
    },
    image: "/images/tarot/themoon.jpeg",
  },
  {
    id: 19,
    card: "The Sun",
    text: "หมายถึง การเติบโต แสงสว่าง มีชีวิตชีวา ไพ่ที่เป็นตัวแทนของความร้อนแรงและสดใส และเร็ว ๆ นี้อาจมีเรื่องดี ๆ เข้ามาเซอร์ไพรส์ก็เป็นได้",
    love: {
      single:
        "บรรยากาศความรักสดใส มั่นใจในเสน่ห์ของตนเอง มีลุ้นสมหวัง พบรักจากกิจกรรมกลางแจ้งหรืองานที่สนุกและมีชีวิตชีวา",
      couple:
        "ความสุขและความชัดเจนกลับมาอีกครั้ง มีโอกาสฉลอง ท่องเที่ยว หรือข่าวดีเรื่องครอบครัว บางคู่มีเกณฑ์เรื่องลูก",
      sources: [
        "https://www.myhora.com/horoscope/tarot-love.aspx",
        "https://www.thairath.co.th/horoscope/tarot/love",
      ],
    },
    image: "/images/tarot/thesun.jpeg",
  },
  {
    id: 20,
    card: "Judgement",
    text: "หมายถึง การตัดสินใจ โอกาสครั้งที่สอง จะมีเรื่องสำคัญมาก ๆ เข้ามาให้ต้องตัดสินใจ ต้องปล่อยอดีตให้ผ่านไปเพื่อให้สิ่งใหม่ ๆ ได้เข้ามาแทน",
    love: {
      single:
        "โอกาสครั้งที่สองปรากฏ อาจเป็นรักเก่าที่กลับมาหรือการเคลียร์ปมในใจจนพร้อมเริ่มใหม่แบบชัดเจนกว่าเดิม",
      couple:
        "ได้เวลาคุยเรื่องใหญ่และตัดสินใจร่วมกัน บางคู่คืนดี บางคู่ยกระดับความสัมพันธ์—ตรงไปตรงมาแล้วเดินหน้าพร้อมกัน",
      sources: [
        "https://www.myhora.com/horoscope/tarot-love.aspx",
        "https://www.thairath.co.th/horoscope/tarot/love",
      ],
    },
    image: "/images/tarot/judgement.jpeg",
  },
  {
    id: 21,
    card: "The World",
    text: "หมายถึง ความสำเร็จ ความสมบูรณ์ ถือเป็นอีกหนึ่งใบดี ๆ อีกหนึ่งใบ มีความสำเร็จเกิดขึ้น ชีวิตเติมเต็มมาก ๆ ด้วย",
    love: {
      single:
        "พร้อมปิดจบวงจรเดิมและเปิดรับความสัมพันธ์ที่ ‘ครบถ้วน’ มากขึ้น มีเกณฑ์พบรักต่างชาติ ต่างถิ่น หรือจากการเดินทางไกล",
      couple:
        "ความรักบรรลุเป้าหมายร่วมกัน เช่น แต่งงาน สร้างบ้าน ย้ายถิ่นฐาน หรือทริปยาว ๆ ที่เติมเต็มชีวิตคู่",
      sources: [
        "https://www.myhora.com/horoscope/tarot-love.aspx",
        "https://www.thairath.co.th/horoscope/tarot/love",
      ],
    },
    image: "/images/tarot/theworld.jpeg",
  },
  {
    id: 22,
    card: "1. ถ้วย",
    text: "หมายถึง ความรัก การเริ่มต้น การมอบสิ่งดี ๆ ให้กับอีกฝ่ายหรืออาจจะเป็นฝ่ายได้รับสิ่งดี ๆ จากผู้อื่น",
    love: {
      single:
        "ไพ่ใบนี้สื่อถึงการเปิดหัวใจครั้งใหม่ คุณมีโอกาสพบรักแบบชุ่มฉ่ำใจหรือมีคนมาสารภาพความในใจ ความสัมพันธ์เริ่มต้นอย่างเป็นธรรมชาติ ค่อย ๆ เรียนรู้กันและกันจากความรู้สึกที่ล้นเอ่อ",
      couple:
        "ความรักกลับมาชื่นมื่นและเติมเต็ม อารมณ์อ่อนโยนเข้าใจกันมากขึ้น หากเคยค้างคาใจกันจะได้เคลียร์ใจผ่านบทสนทนาดี ๆ บางคู่มีลุ้นข่าวดีเรื่องทริปหวาน เซอร์ไพรส์ หรือสมาชิกใหม่",
      sources: [
        "https://www.myhora.com/horoscope/tarot-love.aspx?mode=1",
        "https://www.shitsuren-tarot.com/tarot/ace-of-cups/",
      ],
    },
    image: "/images/tarot/aceofcups.jpeg",
  },
  {
    id: 23,
    card: "2. ถ้วย",
    text: "หมายถึง คนรัก คู่รัก การมอบความรักให้กันและกัน ถ้าชอบใครอยู่อาจมีโอกาสสมหวังนะคะ",
    love: {
      single:
        "มีแววเจอคนที่คลิกกันตั้งแต่แรกพบ ความรู้สึกไปด้วยกันได้ดีและให้เกียรติกัน อาจเริ่มจากการคุยสั้น ๆ แล้วต่อยอดเป็นการนัดพบ—ความสัมพันธ์มีโอกาสพัฒนาเป็นคู่จริง",
      couple:
        "บรรยากาศหวาน กลับมาเข้าอกเข้าใจและยอมรับกันมากขึ้น เรื่องไม่เข้าใจกันจะเคลียร์ได้ด้วยใจที่เท่าเทียม บางคู่มีเกณฑ์ตกลงสถานะ หมั้นหมาย หรือเริ่มแผนสำคัญร่วมกัน",
      sources: [
        "https://www.myhora.com/horoscope/tarot-love.aspx?mode=1",
        "https://www.shitsuren-tarot.com/tarot/two-of-cups/",
      ],
    },
    image: "/images/tarot/twoofcups.jpeg",
  },
  {
    id: 24,
    card: "3. ถ้วย",
    text: "หมายถึง การเฉลิมฉลอง ปาร์ตี้กับเพื่อน ๆ มีความรักแบบเพื่อนฝูง แฮปปี้มีความสุข",
    love: {
      single:
        "เสน่ห์ทางสังคมโดดเด่น เจอคนถูกใจผ่านงานสังสรรค์ เพื่อนแนะนำ หรือกิจกรรมกลุ่ม ความสัมพันธ์สดใสแบบชิล ๆ คุยเพลินและขยับใกล้กันขึ้นทีละนิด",
      couple:
        "มีเรื่องให้ฉลองร่วมกัน—ข่าวดี งานรวมญาติ หรือทริปกับเพื่อน ๆ เติมรอยยิ้มให้คู่รัก จังหวะนี้เน้นแบ่งปันความสุขและประสบการณ์ดี ๆ จะยิ่งผูกพัน",
      sources: [
        "https://www.myhora.com/horoscope/tarot-love.aspx?mode=1",
        "https://www.shitsuren-tarot.com/tarot/three-of-cups/",
      ],
    },
    image: "/images/tarot/threeofcups.jpeg",
  },
  {
    id: 25,
    card: "4. ถ้วย",
    text: "หมายถึง การหยุดนิ่ง ความเบื่อหน่าย แม้จะมีความสุข มีสิ่งดี ๆ รายล้อม แต่กลับเบื่อหน่ายเพราะอยู่แต่ในกรอบเดิม ๆ",
    love: {
      single:
        "หัวใจยังเฉย ๆ กับรักใหม่เพราะกรอบเดิมทำให้มองข้ามโอกาส ลองเปิดมุมมองหรือเปลี่ยนบรรยากาศ จะเห็นคนดี ๆ ที่ยืนรออยู่ใกล้ ๆ มากกว่าที่คิด",
      couple:
        "ความสัมพันธ์ดูนิ่งจนกลายเป็นความเบื่อ ควรชวนกันทำกิจกรรมใหม่ ๆ หรือคุยความต้องการที่แท้จริงอย่างตรงไปตรงมา เพื่อปลุกไฟรักให้กลับมาอีกครั้ง",
      sources: [
        "https://www.myhora.com/horoscope/tarot-love.aspx?mode=1",
        "https://www.shitsuren-tarot.com/tarot/four-of-cups/",
      ],
    },
    image: "/images/tarot/fourofcups.jpeg",
  },
  {
    id: 26,
    card: "5. ถ้วย",
    text: "หมายถึง การสูญเสีย ความเศร้า เหมือนถ้วยที่ล้มลง ความรู้สึกสิ้นหวัง ความหวังพังทลาย",
    love: {
      single:
        "ยังผูกใจกับอดีตที่ทำให้ผิดหวัง จนมองไม่เห็นโอกาสใหม่ ๆ ลองค่อย ๆ เยียวยาและหันกลับมารักตัวเอง แล้วคุณจะเห็น ‘ถ้วยที่ยังเหลือ’ ที่พร้อมให้เริ่มต้น",
      couple:
        "อาจมีเรื่องเสียใจหรือคาดหวังแล้วไม่เป็นดั่งใจ สิ่งสำคัญคือยอมรับความจริง พูดคุยด้วยสติ และมองสิ่งที่ยังดีต่อกันเพื่อเดินหน้าต่ออย่างเข้าใจ",
      sources: [
        "https://www.myhora.com/horoscope/tarot-love.aspx?mode=1",
        "https://www.shitsuren-tarot.com/tarot/five-of-cups/",
      ],
    },
    image: "/images/tarot/fiveofcups.jpeg",
  },
  {
    id: 27,
    card: "6. ถ้วย",
    text: "หมายถึง ความสงบสุข มีคนมาเยี่ยม อาจได้รับเซอร์ไพรส์จากคนอื่น มีการมาหาแบบไม่ทันตั้งตัว ได้รับของฝาก",
    love: {
      single:
        "ความรักอุ่นละมุนแบบย้อนความทรงจำ มีเกณฑ์เจอคนรู้จักเก่า คนบ้านใกล้ หรือเพื่อนเก่าส่งต่อความรู้สึกดี ๆ ความสัมพันธ์ค่อย ๆ โตด้วยความจริงใจ",
      couple:
        "บรรยากาศอบอุ่น นึกถึงช่วงเวลาดี ๆ ร่วมกัน ของขวัญเล็ก ๆ น้อย ๆ หรือการแวะเยี่ยมครอบครัวจะทำให้ผูกพันกันแน่นขึ้น",
      sources: [
        "https://www.myhora.com/horoscope/tarot-love.aspx?mode=1",
        "https://www.shitsuren-tarot.com/tarot/six-of-cups/",
      ],
    },
    image: "/images/tarot/sixofcups.jpeg",
  },
  {
    id: 28,
    card: "7. ถ้วย",
    text: "หมายถึง ความสับสน ตัวเลือกเยอะ เกิดขึ้นได้จากความรู้สึกที่มีมากมายเกินความจำเป็น หรือแม้แต่มีข้อเสนอเข้ามาเยอะมากจนตัดสินใจไม่ถูก",
    love: {
      single:
        "ตัวเลือกมากหรือภาพฝันทำให้สับสน แยกความรู้สึกกับความจริงให้ชัด—ค่อย ๆ ทำความรู้จักทีละคน แล้วหัวใจจะพาไปหาคำตอบที่ใช่",
      couple:
        "ความรักอาจพร่าเลือนเพราะความคาดหวังหรือจินตนาการ ลองตั้งหลักด้วยเป้าหมายร่วมกันและข้อตกลงที่จับต้องได้ เพื่อลดความเข้าใจผิด",
      sources: [
        "https://www.myhora.com/horoscope/tarot-love.aspx?mode=1",
        "https://www.shitsuren-tarot.com/tarot/seven-of-cups/",
      ],
    },
    image: "/images/tarot/sevenofcups.jpeg",
  },
  {
    id: 29,
    card: "8. ถ้วย",
    text: "หมายถึง การจากลา ทอดทิ้ง การเดินหนีจากสิ่งที่ทำให้ผิดหวัง หรือเรื่องนั้น ๆ ได้จบลงแล้ว ได้เวลาก้าวต่อไป",
    love: {
      single:
        "ถึงเวลาวางเรื่องเก่าที่ไม่เติมเต็ม แล้วหันหน้าเดินสู่สิ่งที่ใช่กว่า การปล่อยวางจะพาคุณไปเจอความสัมพันธ์ที่ลึกซึ้งและมีคุณค่ากับใจจริง ๆ",
      couple:
        "บางคู่ต้องถอยออกมาทบทวนเพื่อตามหาความหมายที่แท้จริงของรัก บางคู่เลือกเดินจากสิ่งที่ไม่ดีต่อใจ เพื่อเปิดทางให้คุณภาพชีวิตรักที่ดีกว่า",
      sources: [
        "https://www.myhora.com/horoscope/tarot-love.aspx?mode=1",
        "https://www.shitsuren-tarot.com/tarot/eight-of-cups/",
      ],
    },
    image: "/images/tarot/eightofcups.jpeg",
  },
  {
    id: 30,
    card: "9. ถ้วย",
    text: "หมายถึง สมหวัง ความหวังเป็นจริง สิ่งที่อยากได้กำลังจะกลายเป็นจริงแล้วนะคะ นั่งรอได้เลย",
    love: {
      single:
        "ความมั่นใจและความสุขในตัวเองดึงดูดความรักดี ๆ เข้ามา ความปรารถนาเรื่องความสัมพันธ์มีแนวโน้มเป็นจริง—ให้หัวใจเปิดรับและค่อย ๆ เลือกสิ่งที่เหมาะกับคุณ",
      couple:
        "ช่วงอิ่มเอม รู้สึกพอใจในกันและกัน ความปรารถนาร่วมกันเริ่มเป็นรูปธรรม เช่น บ้าน ทริป หรือโครงการคู่—มีเหตุให้ฉลอง",
      sources: [
        "https://www.myhora.com/horoscope/tarot-love.aspx?mode=1",
        "https://www.shitsuren-tarot.com/tarot/nine-of-cups/",
      ],
    },
    image: "/images/tarot/nineofcups.jpeg",
  },
  {
    id: 31,
    card: "10. ถ้วย",
    text: "หมายถึง ความสุข ครอบครัว การมีทุกอย่างพร้อม มีความสุขแบบสุด ๆ",
    love: {
      single:
        "คุณพร้อมดึงดูดความสัมพันธ์แบบครอบครัวในฝัน อาจพบรักผ่านงานบ้าน งานชุมชน หรือกิจกรรมที่เกี่ยวกับเด็ก ๆ โอกาสยั่งยืนระยะยาวโดดเด่น",
      couple:
        "สมดุลและกลมเกลียว ครอบครัวอบอุ่น มีความสุขใจครบถ้วน บางคู่เดินหน้าสู่การแต่งงาน ขยายครอบครัว หรือวางรากฐานร่วมกันอย่างมั่นคง",
      sources: [
        "https://www.myhora.com/horoscope/tarot-love.aspx?mode=1",
        "https://www.shitsuren-tarot.com/tarot/ten-of-cups/",
      ],
    },
    image: "/images/tarot/tenofcups.jpeg",
  },
  {
    id: 32,
    card: "มหาดเล็กถ้วย",
    text: "หมายถึง ความสนุก ชอบเข้าสังคม ได้พบเจอกับคนมากหน้าหลายตา หรืออาจได้รับข่าวสารบางอย่าง",
    love: {
      single:
        "สายหวานมีลุ้นข้อความน่ารัก การทัก DM หรือการชวนคุยแบบเขิน ๆ เจอคนครีเอทีฟ อารมณ์ศิลป์สูง ความสัมพันธ์เริ่มแบบนุ่มนวลจากไมตรีจิต",
      couple:
        "ความรักละมุนขึ้นด้วยคำพูดดี ๆ เซอร์ไพรส์เล็ก ๆ และการใส่ใจความรู้สึกกัน เหมาะชวนทำกิจกรรมสร้างสรรค์เพื่อเติมสีสันให้หัวใจ",
      sources: [
        "https://www.myhora.com/horoscope/tarot-love.aspx?mode=1",
        "https://www.shitsuren-tarot.com/tarot/page-of-cups/",
      ],
    },
    image: "/images/tarot/pageofcups.jpeg",
  },
  {
    id: 33,
    card: "อัศวินถ้วย",
    text: "หมายถึง นักสู้ นักฝัน การขอร้อง ขอแต่งงาน อยากได้สิ่งใดก็ต้องออกไปฝ่าฟันเอามาให้ได้",
    love: {
      single:
        "มีคนเข้ามาจีบอย่างโรแมนติกหรือคุณกล้าเดินหน้าบอกความรู้สึกเอง เสน่ห์อบอุ่นทำให้การเดตไหลลื่น—ให้โอกาสรู้จักกันจากกิจกรรมที่หัวใจนำทาง",
      couple:
        "ความหวานมาเป็นระยะ ๆ ผ่านคำขอหรือท่าทีเอาใจใส่ อาจมีทริปสั้น ๆ หรือเดตพิเศษ เติมไฟฝันให้รัก—แต่อย่าลืมตามด้วยการลงมือทำจริง",
      sources: [
        "https://www.myhora.com/horoscope/tarot-love.aspx?mode=1",
        "https://www.shitsuren-tarot.com/tarot/knight-of-cups/",
      ],
    },
    image: "/images/tarot/knightofcups.jpeg",
  },
  {
    id: 34,
    card: "ราชินีถ้วย",
    text: "หมายถึง สัญชาตญาณดี การพิจารณา หากต้องตัดสินใจอะไรก็ตาม ต้องคิดทบทวนอย่างรอบคอบ",
    love: {
      single:
        "เสน่ห์ของความอ่อนโยนและการเอาใจใส่ทำให้มีคนอยากเข้าหา เชื่อเสียงหัวใจและสัญชาตญาณของคุณ—คนที่ใช่จะทำให้รู้สึกปลอดภัยและถูกเข้าใจ",
      couple:
        "ความรักลึกซึ้งขึ้นด้วยการรับฟังและโอบอุ้มความรู้สึกกัน ระวังอ่อนไหวเกินไปจนเก็บทุกเรื่องมาคิด—สื่อสารอย่างอ่อนโยนและตั้งขอบเขตที่ดี",
      sources: [
        "https://www.myhora.com/horoscope/tarot-love.aspx?mode=1",
        "https://www.shitsuren-tarot.com/tarot/queen-of-cups/",
      ],
    },
    image: "/images/tarot/queenofcups.jpeg",
  },
  {
    id: 35,
    card: "ราชาถ้วย",
    text: "หมายถึง ฉลาด สุขุม อดทน แม้ว่าจะต้องเจอกับเหตุการณ์ไม่มั่นคงใด ๆ ก็ต้องวางตัวหนักแน่ ใช้เหตุผลมากกว่าอารมณ์",
    love: {
      single:
        "มีแนวโน้มพบคนอารมณ์นิ่ง สุขุม เป็นที่พึ่งทางใจได้ดี หรือคุณเองพัฒนา ‘วุฒิภาวะทางอารมณ์’ จนดึงดูดความรักที่มั่นคงและปลอดภัย",
      couple:
        "ผ่านเรื่องท้าทายด้วยความใจเย็น รับฟังและประคับประคองกันอย่างมีวุฒิภาวะ บรรยากาศรักนิ่ง สุข และสุกงอมต่อการวางแผนระยะยาว",
      sources: [
        "https://www.myhora.com/horoscope/tarot-love.aspx?mode=1",
        "https://www.shitsuren-tarot.com/tarot/king-of-cups/",
      ],
    },
    image: "/images/tarot/kingofcups.jpeg",
  },
];
